import React, { useEffect, useContext, useCallback, useMemo } from 'react';
import useSWR from 'swr';
import { mmAPI } from 'services/Api';
import { navigate } from '@reach/router';
import { UserContext } from 'providers/contexts';
import { FrameUIActionsTypes, useFrameUI } from 'providers/FrameUIProvider';
import useTeam from 'hooks/useTeam';
import { ModalsContext } from 'providers/ModalsProvider';
import ModelAccessModal from 'components/Dashboard/Collections/CollectionAccessModal/ModelAccessModal';
import { ModelTeamContainer } from './ModelTeamContainer';
import { TeamContainer } from './TeamContainer';
import Breadcrumbs from 'components/Common/Breadcrumbs/Breadcrumbs';

const Team = ({ brand_model_id }) => {
  const { user } = useContext(UserContext);
  const { idToken } = user;
  const { dispatch } = useFrameUI();

  const { data: lines } = useSWR(
    ['/api/line/query/brand/', idToken, brand_model_id],
    (url, idToken, brand) => {
      return mmAPI(url, idToken, { brand, cursor: 0 });
    },
    {
      suspense: true,
    }
  );

  const { data: collections } = useSWR(
    ['/api/collection/query/brand/', idToken, brand_model_id],
    (url, idToken, brand) => {
      return mmAPI(url, idToken, { brand, cursor: 0 });
    },
    {
      suspense: true,
    }
  );

  const { setAppModal, setAppModalProps, setOpenAppModal, openAppModal } = useContext(
    ModalsContext
  );

  const {
    teamAccountsState,
    teamInvitesState,
    teamModelAssoc,
    setTeamModelAssoc,
  } = useTeam(idToken, {
    brand_model_id,
    matchMultiTeams: true,
  });

  const modal = (
    <ModelAccessModal
      heading={`${user?.brand?.name} Access`}
      open={openAppModal}
      setOpen={setOpenAppModal}
      allMembers={teamAccountsState}
      allInvites={teamInvitesState}
      model={user?.brand}
    />
  );
  const triggerModelAccessModal = useCallback(
    (model, jobType) => {
      console.log('triggerModelAccessModal', jobType);
      setTeamModelAssoc({ model, jobType });
      setAppModalProps(prev => ({
        ...prev,
        model,
        jobType,
      }));
      setAppModal(modal);
      setOpenAppModal(true);
    },
    [teamAccountsState, teamInvitesState]
  );

  useEffect(() => {
    setAppModalProps(prev => ({
      ...prev,
      heading: `${teamModelAssoc?.model?.name} Access`,
      allMembers: teamAccountsState,
      allInvites: teamInvitesState,
      model: teamModelAssoc?.model,
    }));
  }, [teamAccountsState, teamInvitesState, user?.brand, teamModelAssoc?.model]);

  const popUpOptions = useMemo(
    () => [
      {
        selectItem: 'Add Team Member',
        onClick: () => triggerModelAccessModal(user?.brand, 'admin'),
      },
      {
        selectItem: 'Add Guest',
        onClick: () => triggerModelAccessModal(user?.brand, 'guest'),
      },
    ],
    [user?.brand, brand_model_id]
  );

  useEffect(() => {
    const filterBarEffect = () => {
      dispatch({ type: FrameUIActionsTypes.FILTER_BAR_VISIBLE, payload: true });
      dispatch({
        type: FrameUIActionsTypes.FILTER_BAR_OPTIONS,
        payload: [...popUpOptions],
      });
      return () => {
        dispatch({ type: FrameUIActionsTypes.FILTER_BAR_RESET });
      };
    };
    return filterBarEffect();
  }, []);

  const pages = [
    { title: 'Settings', link: `/settings` },
    { title: 'Manage Team', link: `/team` },
  ];

  return (
    <>
      <div className='TeamView'>
        <Breadcrumbs pages={pages} />
        <div className='TeamTables'>
          <TeamContainer
            viewMode={'MANAGE'}
            key={brand_model_id}
            lines={lines}
            collections={collections}
            brand_model_id={brand_model_id}
          />
        </div>
      </div>
    </>
  );
};
export default Team;
